import React, { createContext, useReducer } from "react"
import PropTypes from "prop-types"
import {
  initialModalPartidaState,
  modalPartidaReducer,
} from "./modalPartidaReducer"

export const ModalPartidaContext = createContext()

export const ModalPartidaProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    modalPartidaReducer,
    initialModalPartidaState,
  )

  return (
    <ModalPartidaContext.Provider value={{ state, dispatch }}>
      {children}
    </ModalPartidaContext.Provider>
  )
}

ModalPartidaProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
